import { InjectionToken } from '@angular/core';

export const API_URL = new InjectionToken<string>('ApiUrl');
export const SOCKET_URL = new InjectionToken<string>('SocketUrl');